/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { MappedSearchProductData } from '../../interface';

export function getSearchVariablesFromProductRecords(
  firstRecNum: number,
  records?: MappedSearchProductData['records']
): {
  searchOriginalPartTypeId: string;
  searchProductRepositoryId: string;
  searchResultPosition: string;
} {
  let searchOriginalPartTypeId = '';
  let searchProductRepositoryId = '';
  let searchResultPosition = '';

  records?.forEach(({ originalPartTypeId, productRepositoryId }, index: number) => {
    const nonExistentValue = 'N/A'; // this is a business requirement to use N/A for null or empty values

    const separator = records.length - 1 !== index ? '|' : '';
    searchOriginalPartTypeId += (originalPartTypeId || nonExistentValue) + separator;
    searchProductRepositoryId += (productRepositoryId || nonExistentValue) + separator;
    searchResultPosition += `${`${firstRecNum} ${index}` || nonExistentValue} ${separator}`;
  });
  return {
    searchOriginalPartTypeId,
    searchProductRepositoryId,
    searchResultPosition,
  };
}
